import type { MutableRefObject } from 'react';
import { memo } from 'react';

import { Typography } from '@interstate/components/Typography';

import { ManualRebatesCardContent } from './Rebates.style';
import { RebatesEdit } from './RebatesEdit';
import { INCENTIVES } from '../../constants';

type ManualRebatesCardProps = {
    isIncentivesFormDirtyRef?: MutableRefObject<boolean>;
};

export const ManualRebatesCard = memo(function ManualRebatesCard({ isIncentivesFormDirtyRef }: ManualRebatesCardProps) {
    return (
        <>
            <Typography variant="h3">{INCENTIVES}</Typography>
            <ManualRebatesCardContent variant="body-sm" color="base.color.gray.600">
                <RebatesEdit isIncentivesFormDirtyRef={isIncentivesFormDirtyRef} />
            </ManualRebatesCardContent>
        </>
    );
});
